import Vue from 'vue'
import BloomSurveyDialog from '../../components/public/BloomSurveyDialog.vue'
import i18n from '../../i18n'
import store from '../../store'
import { setBloomSurveyHost, getBloomSurveyHost } from './host'
import {
  markBloomSurveyPending,
  tryShowBloomSurveyDialog,
  clearBloomSurveyPending
} from './pending'

let instance = null

export {
  setBloomSurveyHost,
  getBloomSurveyHost,
  markBloomSurveyPending,
  tryShowBloomSurveyDialog,
  clearBloomSurveyPending
}

function getInstance () {
  const host = getBloomSurveyHost()
  if (host && typeof host.open === 'function') {
    return host
  }
  if (!instance) {
    const Ctor = Vue.extend(BloomSurveyDialog)
    const mountNode = document.createElement('div')
    document.body.appendChild(mountNode)
    instance = new Ctor({
      i18n,
      store
    }).$mount(mountNode)
  }
  return instance
}

function install (options = {}) {
  if (options === false || options.close === true) {
    const vm = getBloomSurveyHost() || instance
    if (vm) vm.hide()
    return vm
  }
  const vm = getInstance()
  Vue.nextTick(() => {
    vm.open(options || {})
  })
  return vm
}

install.close = () => {
  const vm = getBloomSurveyHost() || instance
  if (vm) vm.hide()
}

BloomSurveyDialog.install = install
BloomSurveyDialog.close = install.close

export default BloomSurveyDialog



// WEBPACK FOOTER //
// ./src/plugin/BloomSurveyDialog/index.js